module.exports = {
	"elementName": "ObjectSchema",
	"name": "Charts",
	"containers": [
		{
			"name": "container",
			"elementName": "Container",
			"style": {
				"top": 0,
				"left": 0,
				"width": 400,
				"height": 2000,
				"position": "relative"
			},
			"props": {},
			"boxes": [
				{
					"name": "Bar",
					"elementName": "Chart.Bar",
					"style": {
						"top": 0,
						"left": 0,
						"width": 400,
						"height": 250,
						"transform": {}
					},
					"props": {
						"data": [
							[
								{
									"v": 28,
									"name": "apple"
								},
								{
									"v": 49,
									"name": "apple"
								}
							],
							[
								{
									"v": 66,
									"name": "banana"
								},
								{
									"v": 41,
									"name": "banana"
								}
							],
							[
								{
									"v": 13,
									"name": "grape"
								},
								{
									"v": 21,
									"name": "grape"
								}
							]
						],
						"accessorKey": "v",
						"options": {
							"width": 350,
							"height": 200,
							"margin": {
								"left": 30
							},
							"animate": {},
							"axisY": {},
							"axisX": {}
						}
					},
					"bindings": {}
				},
				{
					"name": "Pie",
					"elementName": "Chart.Pie",
					"style": {
						"top": 990,
						"left": 0,
						"width": 400,
						"height": 350,
						"transform": {}
					},
					"props": {
						"data": [
							{
								"name": "Amazonas",
								"population": 8663019
							},
							{
								"name": "Piauí",
								"population": 4479670
							},
							{
								"name": "Rio",
								"population": 2629739
							},
							{
								"name": "Pernambuco",
								"population": 8444788
							},
							{
								"name": "Rondônia",
								"population": 4412241
							},
							{
								"name": "Alagoas",
								"population": 5106314
							}
						],
						"accessorKey": "population",
						"options": {
							"width": 350,
							"height": 350,
							"r": 100,
							"R": 180,
							"animate": {}
						}
					},
					"bindings": {}
				},
				{
					"name": "Tree",
					"elementName": "Chart.Tree",
					"style": {
						"top": 530,
						"left": 0,
						"width": 400,
						"height": 200,
						"transform": {}
					},
					"props": {
						"data": {
							"name": "Root",
							"children": [
								{
									"name": "Paraná",
									"children": [
										{
											"name": "Gibson"
										},
										{
											"name": "Gaylord"
										}
									]
								},
								{
									"name": "Rio Grande do Sul",
									"children": [
										{
											"name": "Johnston"
										},
										{
											"name": "Trantow"
										}
									]
								}
							]
						},
						"options": {
							"width": 270,
							"height": 170,
							"animate": {}
						}
					},
					"bindings": {}
				},
				{
					"name": "SmoothLine",
					"elementName": "Chart.SmoothLine",
					"style": {
						"top": 740,
						"left": 0,
						"width": 400,
						"height": 200,
						"transform": {}
					},
					"props": {
						"data": [
							[
								{
									"x": -10,
									"y": -1000
								},
								{
									"x": -9,
									"y": -729
								},
								{
									"x": -8,
									"y": -512
								},
								{
									"x": -7,
									"y": -343
								},
								{
									"x": -6,
									"y": -216
								},
								{
									"x": -5,
									"y": -125
								},
								{
									"x": -4,
									"y": -64
								},
								{
									"x": -3,
									"y": -27
								},
								{
									"x": -2,
									"y": -8
								},
								{
									"x": -1,
									"y": -1
								},
								{
									"x": 0,
									"y": 0
								},
								{
									"x": 1,
									"y": 1
								},
								{
									"x": 2,
									"y": 8
								},
								{
									"x": 3,
									"y": 27
								},
								{
									"x": 4,
									"y": 64
								},
								{
									"x": 5,
									"y": 125
								},
								{
									"x": 6,
									"y": 216
								},
								{
									"x": 7,
									"y": 343
								},
								{
									"x": 8,
									"y": 512
								},
								{
									"x": 9,
									"y": 729
								},
								{
									"x": 10,
									"y": 1000
								}
							],
							[
								{
									"x": -10,
									"y": 100
								},
								{
									"x": -9,
									"y": 81
								},
								{
									"x": -8,
									"y": 64
								},
								{
									"x": -7,
									"y": 49
								},
								{
									"x": -6,
									"y": 36
								},
								{
									"x": -5,
									"y": 25
								},
								{
									"x": -4,
									"y": 16
								},
								{
									"x": -3,
									"y": 9
								},
								{
									"x": -2,
									"y": 4
								},
								{
									"x": -1,
									"y": 1
								},
								{
									"x": 0,
									"y": 0
								},
								{
									"x": 1,
									"y": 1
								},
								{
									"x": 2,
									"y": 4
								},
								{
									"x": 3,
									"y": 9
								},
								{
									"x": 4,
									"y": 16
								},
								{
									"x": 5,
									"y": 25
								},
								{
									"x": 6,
									"y": 36
								},
								{
									"x": 7,
									"y": 49
								},
								{
									"x": 8,
									"y": 64
								},
								{
									"x": 9,
									"y": 81
								},
								{
									"x": 10,
									"y": 100
								}
							]
						],
						"xKey": "x",
						"yKey": "y",
						"options": {
							"width": 320,
							"height": 160,
							"animate": {},
							"axisY": {},
							"axisX": {}
						}
					},
					"bindings": {}
				},
				{
					"name": "StockLine",
					"elementName": "Chart.StockLine",
					"style": {
						"top": 270,
						"left": 0,
						"width": 400,
						"height": 200,
						"transform": {}
					},
					"props": {
						"data": [
							[
								{
									"x": 0,
									"y": 21853
								},
								{
									"x": 1,
									"y": 29253
								},
								{
									"x": 2,
									"y": 26592
								},
								{
									"x": 3,
									"y": 90633
								},
								{
									"x": 4,
									"y": 87847
								},
								{
									"x": 5,
									"y": 60759
								},
								{
									"x": 6,
									"y": 98350
								},
								{
									"x": 7,
									"y": 15172
								},
								{
									"x": 8,
									"y": 59380
								},
								{
									"x": 9,
									"y": 26121
								},
								{
									"x": 10,
									"y": 70079
								},
								{
									"x": 11,
									"y": 21245
								},
								{
									"x": 12,
									"y": 31776
								},
								{
									"x": 13,
									"y": 38150
								},
								{
									"x": 14,
									"y": 85939
								},
								{
									"x": 15,
									"y": 34264
								},
								{
									"x": 16,
									"y": 76476
								},
								{
									"x": 17,
									"y": 14385
								},
								{
									"x": 18,
									"y": 24933
								},
								{
									"x": 19,
									"y": 89404
								},
								{
									"x": 20,
									"y": 22059
								},
								{
									"x": 21,
									"y": 45639
								},
								{
									"x": 22,
									"y": 97499
								},
								{
									"x": 23,
									"y": 39439
								},
								{
									"x": 24,
									"y": 18832
								},
								{
									"x": 25,
									"y": 94987
								},
								{
									"x": 26,
									"y": 15591
								},
								{
									"x": 27,
									"y": 96627
								},
								{
									"x": 28,
									"y": 26990
								},
								{
									"x": 29,
									"y": 33868
								},
								{
									"x": 30,
									"y": 16873
								},
								{
									"x": 31,
									"y": 47604
								},
								{
									"x": 32,
									"y": 94160
								},
								{
									"x": 33,
									"y": 42091
								},
								{
									"x": 34,
									"y": 57599
								},
								{
									"x": 35,
									"y": 91972
								},
								{
									"x": 36,
									"y": 74134
								},
								{
									"x": 37,
									"y": 30449
								},
								{
									"x": 38,
									"y": 60658
								},
								{
									"x": 39,
									"y": 75862
								},
								{
									"x": 40,
									"y": 93049
								},
								{
									"x": 41,
									"y": 70351
								},
								{
									"x": 42,
									"y": 74705
								},
								{
									"x": 43,
									"y": 23833
								}
							],
							[
								{
									"x": 0,
									"y": 196861
								},
								{
									"x": 1,
									"y": 118926
								},
								{
									"x": 2,
									"y": 83231
								},
								{
									"x": 3,
									"y": 106127
								},
								{
									"x": 4,
									"y": 72058
								},
								{
									"x": 5,
									"y": 198664
								},
								{
									"x": 6,
									"y": 119113
								},
								{
									"x": 7,
									"y": 98125
								},
								{
									"x": 8,
									"y": 126790
								},
								{
									"x": 9,
									"y": 180178
								},
								{
									"x": 10,
									"y": 71834
								},
								{
									"x": 11,
									"y": 56491
								},
								{
									"x": 12,
									"y": 187290
								},
								{
									"x": 13,
									"y": 73670
								},
								{
									"x": 14,
									"y": 168966
								},
								{
									"x": 15,
									"y": 116421
								},
								{
									"x": 16,
									"y": 169372
								},
								{
									"x": 17,
									"y": 142307
								},
								{
									"x": 18,
									"y": 196620
								},
								{
									"x": 19,
									"y": 71154
								},
								{
									"x": 20,
									"y": 86103
								},
								{
									"x": 21,
									"y": 117930
								},
								{
									"x": 22,
									"y": 192450
								},
								{
									"x": 23,
									"y": 106636
								},
								{
									"x": 24,
									"y": 149058
								},
								{
									"x": 25,
									"y": 170687
								},
								{
									"x": 26,
									"y": 79467
								},
								{
									"x": 27,
									"y": 74543
								},
								{
									"x": 28,
									"y": 64683
								},
								{
									"x": 29,
									"y": 81830
								},
								{
									"x": 30,
									"y": 63483
								},
								{
									"x": 31,
									"y": 65171
								},
								{
									"x": 32,
									"y": 191446
								},
								{
									"x": 33,
									"y": 144120
								},
								{
									"x": 34,
									"y": 158076
								},
								{
									"x": 35,
									"y": 128886
								},
								{
									"x": 36,
									"y": 153584
								},
								{
									"x": 37,
									"y": 79166
								},
								{
									"x": 38,
									"y": 153772
								},
								{
									"x": 39,
									"y": 171496
								},
								{
									"x": 40,
									"y": 114958
								},
								{
									"x": 41,
									"y": 141760
								},
								{
									"x": 42,
									"y": 63243
								},
								{
									"x": 43,
									"y": 120604
								}
							],
							[
								{
									"x": 0,
									"y": 224815
								},
								{
									"x": 1,
									"y": 275849
								},
								{
									"x": 2,
									"y": 260010
								},
								{
									"x": 3,
									"y": 132410
								},
								{
									"x": 4,
									"y": 249230
								},
								{
									"x": 5,
									"y": 165609
								},
								{
									"x": 6,
									"y": 154338
								},
								{
									"x": 7,
									"y": 166459
								},
								{
									"x": 8,
									"y": 151448
								},
								{
									"x": 9,
									"y": 127123
								},
								{
									"x": 10,
									"y": 259850
								},
								{
									"x": 11,
									"y": 159529
								},
								{
									"x": 12,
									"y": 112642
								},
								{
									"x": 13,
									"y": 196442
								},
								{
									"x": 14,
									"y": 159436
								},
								{
									"x": 15,
									"y": 242272
								},
								{
									"x": 16,
									"y": 113389
								},
								{
									"x": 17,
									"y": 206191
								},
								{
									"x": 18,
									"y": 228629
								},
								{
									"x": 19,
									"y": 109142
								},
								{
									"x": 20,
									"y": 297591
								},
								{
									"x": 21,
									"y": 123266
								},
								{
									"x": 22,
									"y": 186345
								},
								{
									"x": 23,
									"y": 182528
								},
								{
									"x": 24,
									"y": 111063
								},
								{
									"x": 25,
									"y": 135532
								},
								{
									"x": 26,
									"y": 181399
								},
								{
									"x": 27,
									"y": 175396
								},
								{
									"x": 28,
									"y": 116050
								},
								{
									"x": 29,
									"y": 176508
								},
								{
									"x": 30,
									"y": 270834
								},
								{
									"x": 31,
									"y": 248593
								},
								{
									"x": 32,
									"y": 256634
								},
								{
									"x": 33,
									"y": 198987
								},
								{
									"x": 34,
									"y": 123634
								},
								{
									"x": 35,
									"y": 138230
								},
								{
									"x": 36,
									"y": 150726
								},
								{
									"x": 37,
									"y": 127421
								},
								{
									"x": 38,
									"y": 268145
								},
								{
									"x": 39,
									"y": 181416
								},
								{
									"x": 40,
									"y": 245245
								},
								{
									"x": 41,
									"y": 255474
								},
								{
									"x": 42,
									"y": 101244
								},
								{
									"x": 43,
									"y": 197658
								}
							]
						],
						"xKey": "x",
						"yKey": "y",
						"options": {
							"width": 315,
							"height": 170,
							"animate": {},
							"axisY": {},
							"axisX": {}
						}
					},
					"bindings": {}
				},
				{
					"name": "Scatterplot",
					"elementName": "Chart.Scatterplot",
					"style": {
						"top": 1380,
						"left": 0,
						"width": 400,
						"height": 250,
						"transform": {}
					},
					"props": {
						"data": [
							[
								{
									"title": "Ceará",
									"rating": 4.41,
									"episode": 0
								},
								{
									"title": "Pernambuco",
									"rating": 2.13,
									"episode": 1
								},
								{
									"title": "Amazonas",
									"rating": 8.47,
									"episode": 2
								},
								{
									"title": "Rio Grande do Norte",
									"rating": 8.75,
									"episode": 3
								},
								{
									"title": "Mato Grosso do Sul",
									"rating": 5.54,
									"episode": 4
								},
								{
									"title": "Mato Grosso",
									"rating": 8.24,
									"episode": 5
								},
								{
									"title": "Pernambuco",
									"rating": 6.52,
									"episode": 6
								},
								{
									"title": "Ceará",
									"rating": 0.85,
									"episode": 7
								},
								{
									"title": "Amapá",
									"rating": 7.19,
									"episode": 8
								},
								{
									"title": "Ceará",
									"rating": 0.85,
									"episode": 9
								},
								{
									"title": "Rio de Janeiro",
									"rating": 5.44,
									"episode": 10
								},
								{
									"title": "São Paulo",
									"rating": 6.45,
									"episode": 11
								},
								{
									"title": "Minas Gerais",
									"rating": 1.56,
									"episode": 12
								},
								{
									"title": "Paraíba",
									"rating": 2.39,
									"episode": 13
								},
								{
									"title": "Goiás",
									"rating": 2.09,
									"episode": 14
								},
								{
									"title": "Mato Grosso",
									"rating": 5.57,
									"episode": 15
								}
							]
						],
						"xKey": "episode",
						"yKey": "rating",
						"options": {
							"width": 300,
							"height": 200,
							"animate": {},
							"axisY": {},
							"axisX": {}
						}
					},
					"bindings": {}
				},
				{
					"name": "Radar",
					"elementName": "Chart.Radar",
					"style": {
						"top": 1660,
						"left": 0,
						"width": 400,
						"height": 400,
						"transform": {}
					},
					"props": {
						"data": [
							{
								"speed": 70,
								"balance": 24,
								"explosives": 99,
								"energy": 37,
								"flexibility": 73,
								"agility": 87,
								"endurance": 20
							}
						],
						"options": {
							"width": 350,
							"height": 350,
							"r": 150,
							"max": 130,
							"animate": {}
						}
					},
					"bindings": {}
				}
			],
			"containers": []
		}
	],
	"props": {
		"context": {}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/toolbox/templates/Chart.json
 ** module id = 965
 ** module chunks = 0
 **/